module.exports = __webpack_public_path__ + "img/ekonomistyrning_logo.f1fb9bd2.png";